import React from 'react';
import '../Styles/ResourcesCard.css';
import Card from '../JS/Card';

const ResourceCard = ({icon, title, description, buttonText, link}) => {
  return (
    <div className="resource-card-container">
      <Card icon={icon} title={title} description={description}/>
        <a href={link} target="_blank" rel="noopener noreferrer">
          <button className="card-button">{buttonText}</button>
        </a>
    </div>
  );
};

export default ResourceCard;